exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".logo-img[data-v-0d5fbb54]{background:transparent!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d5fbb54","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?data=@import "./src/scss/base";!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/engagement/common/sidebar/SideBar.vue
// module id = 812
// module chunks = 1